import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
	selector: 'vb-lxp-swiss-timing-iframe',
	templateUrl: './swiss-timing-iframe.component.html',
	styleUrls: ['./swiss-timing-iframe.component.css'],
	imports: [CommonModule]
})
export class SwissTimingIframeComponent implements OnInit {
	iframeUrl: SafeResourceUrl = '';
	isQaEnvironment = false;
	scriptLoaded = false;
	private readonly EMBEDDED_FRAME_ID = 'liveStats';

	// Environment URLs
	private readonly QA_IFRAME_BASE_URL = 'https://racing.liveresults.uat-sports.swisstiming.com/index.html?profile=sro&live=true';
	private readonly PROD_IFRAME_BASE_URL = 'https://racing.liveresults.swisstiming.com/index.html?profile=sro&live=true';
	// private readonly PROD_LISTENER_SCRIPT_URL = 'https://www.liveresults.swisstiming.com/listener/iframe_listener.js';

	constructor(
		private activatedRoute: ActivatedRoute,
		private sanitizer: DomSanitizer
	) { }

	ngOnInit(): void {
		this.activatedRoute.queryParams.subscribe((params) => {
			this.isQaEnvironment = params['swisstiming'] === 'qa';
			this.buildIframeUrl();
			// this.loadListenerScript();
		});
	}

	private buildIframeUrl(): void {
		const url = this.isQaEnvironment
			? this.QA_IFRAME_BASE_URL
			: this.PROD_IFRAME_BASE_URL;
		this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url.toString());
	}

	// private loadListenerScript(): void {
	// 	if (this.scriptLoaded) {
	// 		return;
	// 	}

	// 	const script = document.createElement('script');
	// 	script.type = 'text/javascript';
	// 	// script.src = this.PROD_LISTENER_SCRIPT_URL;
	// 	script.async = true;

	// 	script.onload = () => {
	// 		console.log('Swisstiming iframe listener script loaded successfully');
	// 		this.scriptLoaded = true;
	// 	};

	// 	script.onerror = () => {
	// 		console.error('Failed to load Swisstiming iframe listener script');
	// 	};

	// 	document.head.appendChild(script);
	// }

	registerDomain(): void {
		const globalWindow = window as Window & {
			registerDomain?: () => void;
			registerDemo?: () => void;
		};
		const registerDomainFn = globalWindow.registerDomain ?? globalWindow.registerDemo;

		if (typeof registerDomainFn === 'function') {
			registerDomainFn();
			return;
		}

		const data = {
			key: 'host',
			value: window.location.origin
		};

		window.setTimeout(() => {
			try {
				window.frames[this.EMBEDDED_FRAME_ID].postMessage(data, '*');
			} catch {
				const embeddedFrame = document.getElementById(this.EMBEDDED_FRAME_ID) as HTMLIFrameElement | null;
				embeddedFrame?.contentWindow?.postMessage(data, '*');
			}
		}, 100);
	}
}
